import React from "react";
import { getFeedbackData } from "../../services/pendingService";
import { useState, useEffect, useRef } from "react";
import { toast } from "react-toastify";
import { Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import paginationFactory from "react-bootstrap-table2-paginator";
import BootstrapTable from "react-bootstrap-table-next";
import moment from "moment";
import {
  checkPermissionStatus,
  generateMaskedPII,
  getCompanyTimezoneDateTime,
} from "helpers/utils";

import arrow_btn from "../../assets/images/icon/arrow-btn.svg";
import { decryptDataFromArray } from "helpers/EncDec";
import right_arrow from "../../assets/images/icon/right-arrow-table.svg";
import { useTranslation } from "react-i18next";

///////rohit-code//////

function FeedbackList(props) {
  const { t } = useTranslation();
  const [dataList, setDataList] = useState([]);
  // Fetch Listing Data
  useEffect(() => {
    getApplicantData();
    document.title = "NeuroTal - Feedback Received";
  }, []);

  const columns = [
    {
      dataField: "job_user.name",
      text: t(`Feedbacks.User Name`),
      classes: "text-center",
      headerClasses: "text-center",
    },
    {
      dataField: "job_user.email_id",
      text: t(`Feedbacks.User Email`),
      classes: "text-center",
      headerClasses: "text-center",
      formatter: (cell, row) => (
        <>{generateMaskedPII(row?.job_user?.email_id)}</>
      ),
    },
    {
      dataField: "feedback_type",
      text: t(`Feedbacks.Feedback Type`),
      classes: "text-center ",
      headerClasses: "text-center",
    },
    {
      dataField: "feedback_text",
      text: t(`Feedbacks.Feedback/Query`),
      classes: "text-left white-hidden-img left",
      headerClasses: "text-left",
      formatter: cellContent => <ReadMore content={cellContent} />,
    },
    {
      dataField: "created",
      text: t(`Feedbacks.Created On`),
      classes: "text-center",
      headerClasses: "text-center ",
      formatter: cell => {
        return moment(getCompanyTimezoneDateTime(cell))?.format(
          "DD MMM YYYY hh:mm:ss a"
        );
      },
    },
    // Add more columns as needed
  ];

  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      {t(`Feedbacks.Showing rows`, { from, to, size })}
    </span>
  );
  let options = {
    paginationSize: 1,
    pageStartIndex: 1,
    alwaysShowAllBtns: true, // Always show next and previous button
    withFirstAndLast: true, // Hide the going to First and Last page button
    hideSizePerPage: true, // Hide the sizePerPage dropdown always
    hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: false,
    prePageText: false,
    nextPageText: false,
    lastPageText: false,
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: false,
  };

  const rowClasses = (row, rowIndex) => {
    return rowIndex % 2 === 0 ? "even-row" : "odd-row";
  };

  const getApplicantData = async () => {
    await getFeedbackData({})
      .then(res => {
        let responseData = res?.data;
        responseData = decryptDataFromArray(responseData);

        setDataList(responseData?.data || []);
      })
      .catch(err => {
        let errorMsg = JSON.stringify(err?.response?.message);
        toast.error(errorMsg || t(`Feedbacks.Something Went Wrong`));
      });
  };

  

  const ReadMore = ({ content }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const toggleReadMore = () => setIsExpanded(!isExpanded);

    const maxLength = 100; // Adjust to your preferred character limit

    // If content is short, show it fully without any button
    if (content.length <= maxLength) {
      return <>{content}</>;
    }

    return (
      <div>
        {isExpanded ? content : `${content.substring(0, maxLength)}...`}
        <button onClick={toggleReadMore} className="readmoreless">
          {isExpanded ? " Read Less" : "Read More"}
        </button>
      </div>
    );
  };

  const tableWrapperRef = useRef(null);
  const handleScroll = direction => {
    if (tableWrapperRef.current) {
      const scrollAmount = 100; // Adjust this value as needed
      tableWrapperRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    const theme = localStorage.getItem("company_theme");
    if (theme) {
      document.body.classList.add(`theme-${theme}`);
    }
  }, []);
  if (!checkPermissionStatus("feedbacks", "view")) {
    return (
      <div className="page-content">
        <h4 className="text-center"> {t(`Feedbacks.Access Denied`)}</h4>
      </div>
    );
  }

  return (
    <>
      <div className="pending-list-page feedbacks  feedbacklist-master  departmentpage">
        <div className="joblist-container create-vacancy position-relative mb-2">
          <div className="align-items-center feedback-card-row d-flex justify-content-between  py-2 pt-0">
            <Link to="/dashboard">
              <h5 className="text-uppercase heading-one">
                <img src={arrow_btn} alt="arrow_btn" />
                {t(`Feedbacks.Feedback Received`)}
              </h5>
            </Link>

            <div className="tale-text right-panel feedbacks mobile-arrow mb-0">
              <button
                className="button left"
                onClick={() => handleScroll("left")}
                data-tooltip="Scroll Left"
              >
                <img src={right_arrow} alt="right-arrow" />
              </button>
              <button
                className="button right"
                onClick={() => handleScroll("right")}
                data-tooltip="Scroll Right"
              >
                <img src={right_arrow} alt="right-arrow" />
              </button>
            </div>
          </div>
        </div>

        <div className="outerTab-box-wrapper below-vacancy feedbacklist-cards applicationcard-table">
          <div className="tab-content" id="pills-tabContent">
            <div
              className="tab-pane fade show active"
              id="pills-home"
              role="tabpanel"
              // aria-labelledby="pills-home-tab"
            >
              <div className="tabel-application table-responsive white-space-row  pb-3">
                <div className="timeto-hire-card userlist  when-data-low  masterstate-cards">
                  <div className="table-custome-class range-custome">
                    <div className="scroll-container">
                      <div className="table-pending-list">
                        {dataList?.length > 0 && (
                          <div className="table-wrapper" ref={tableWrapperRef}>
                            <BootstrapTable
                              keyField="id"
                              data={dataList}
                              columns={columns}
                              pagination={paginationFactory(options)}
                              rowClasses={rowClasses}
                            />
                          </div>
                        )}

                        {dataList?.length === 0 && (
                          // <p className="text-center">
                          //   {t(`Feedbacks.No Data Available`)}
                          // </p>

                          <div className="no-data data-available">
                            <img
                              src="../../img/data-not-available.png"
                              alt="data not availble"
                            />
                            <h3>{t(`Feedbacks.No Item Found`)}</h3>
                            <p>{t(`Feedbacks.No Item Msg`)}</p>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default FeedbackList;
